import { forwardRef, useImperativeHandle } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Box, TextField } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { DatePicker } from '@material-ui/pickers'
import PropTypes from 'prop-types'

import constants from 'constants/index'
import schema from './schema'

const RegulationVersionForm = forwardRef(
  (
    {
      onSubmit = () => {},
      type = constants.regulations.FORM_TYPES.EDIT,
      regulationVersion = {},
    },
    ref,
  ) => {
    const theme = useTheme()

    const { control, handleSubmit, errors, watch } = useForm({
      validationSchema: schema,
      defaultValues: {
        message: regulationVersion?.message || '',
        url: regulationVersion?.url || '',
        startsAt: regulationVersion?.startsAt
          ? new Date(regulationVersion.startsAt)
          : new Date(),
        endsAt: regulationVersion?.endsAt
          ? new Date(regulationVersion.endsAt)
          : null,
        observation: regulationVersion?.observation || '',
      },
    })

    const disabled = type === constants.regulations.FORM_TYPES.SHOW

    const startsAt = watch('startsAt')

    useImperativeHandle(ref, () => ({
      submit: () =>
        new Promise((resolve) => {
          handleSubmit(resolve, () => resolve(null))()
        }),
    }))

    return (
      <Box
        component="form"
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        py={1}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Controller
          as={
            <TextField
              fullWidth
              label="Mensagem"
              multiline
              minRows={4}
              maxRows={6}
              error={!!errors?.message}
              helperText={errors?.message?.message}
              disabled={disabled}
            />
          }
          control={control}
          name="message"
          mode="onBlur"
        />
        <Controller
          as={
            <TextField
              fullWidth
              label="URL"
              type="url"
              error={!!errors?.url}
              helperText={errors?.url?.message}
              disabled={disabled}
            />
          }
          control={control}
          name="url"
          mode="onBlur"
        />
        <Box display="flex" gridGap={theme.spacing(2)}>
          <Controller
            as={
              <DatePicker
                fullWidth
                label="Data de início"
                format="DD/MM/yyyy"
                error={!!errors?.startsAt}
                helperText={errors?.startsAt?.message}
                onChange={(newValue) => ({ value: newValue })}
                disabled={disabled}
              />
            }
            control={control}
            name="startsAt"
            mode="onChange"
          />
          <Controller
            as={
              <DatePicker
                fullWidth
                label="Prazo"
                format="DD/MM/yyyy"
                clearable
                minDate={startsAt}
                minDateMessage="Prazo não pode ser anterior à data de início"
                error={!!errors?.endsAt}
                helperText={errors?.endsAt?.message}
                onChange={(newValue) => ({ value: newValue })}
                disabled={disabled}
              />
            }
            control={control}
            name="endsAt"
            mode="onChange"
          />
        </Box>
        <Controller
          as={
            <TextField
              fullWidth
              label="Observações"
              multiline
              minRows={4}
              maxRows={6}
              error={!!errors?.observation}
              helperText={errors?.observation?.message}
              disabled={disabled}
            />
          }
          control={control}
          name="observation"
          mode="onBlur"
        />
      </Box>
    )
  },
)

RegulationVersionForm.propTypes = {
  onSubmit: PropTypes.func,
  type: PropTypes.oneOf(Object.values(constants.regulations.FORM_TYPES)),
  regulationVersion: PropTypes.object,
}

export default RegulationVersionForm
